import { useEffect } from "react";
import { useAppDispatch } from "hooks/hooks";
import {
  getCarnetEmployees, setSearchModalOpen,
} from "../main.slice";
import { IGetCarnetEmployeesRequestParams }
  from "Dashboard/scenes/Carnets/domain/IGetCarnetEmployeesRequestParams";
import {
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormReset,
  UseFormSetFocus
} from "react-hook-form";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesCarnets from "../../../styles/popover.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";

interface IProps {
  handleSubmit: UseFormHandleSubmit<IGetCarnetEmployeesRequestParams>;
  register: UseFormRegister<IGetCarnetEmployeesRequestParams>;
  reset: UseFormReset<IGetCarnetEmployeesRequestParams>;
  setFocus: UseFormSetFocus<IGetCarnetEmployeesRequestParams>;
  defaultValues: IGetCarnetEmployeesRequestParams;
}

const SearchPopover = (props: IProps) => {
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setSearchModalOpen(false));
  };

  const onSubmit = async (data: IGetCarnetEmployeesRequestParams) => {
    try {
      dispatch(getCarnetEmployees(data));
      close();
    } catch (err) {
      console.error(err);
    }
  };

  const { register, handleSubmit, reset, setFocus, defaultValues } = props;

  useEffect(() => {
    setFocus("nameKey");
  }, [setFocus]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}
      className={`${classesCarnets.searchPopover} ${classes.basicPopover}`}
    >
      <input
        type="hidden"
        {...register("carnetDataFrom", { required: true })}
      />
      <input type="hidden" {...register("carnetDataTo", { required: true })} />
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>ime zaposlenog</label>
          <input type="text" className={classes.itemBorder}
            {...register("nameKey")} />
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.buttons}>
          <button className={classes.iconButton} type="submit">
            <FontAwesomeIcon
              icon={faLongArrowAltDown}
              className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default SearchPopover;
